import { defineComponent as _defineComponent } from 'vue'
import { useBreakpoint, useSwiperElement } from '~/composables';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryAccessories',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {



const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');

const swiperOptions = {
  observer: true,
  slidesPerView: 'auto',
  spaceBetween: 16,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 180,
    snapOnRelease: true,
  },
};

const swiperEl = useSwiperElement(swiperOptions);

return { __sfc: true,isDesktop, swiperOptions, swiperEl }
}

})